import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import {
  VueAuthenticate
} from 'vue-authenticate'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import editor from 'vue2-medium-editor'
import {
  IP_ADRESS
} from './../../deploy_conf.js'
import { uuid } from 'vue-uuid' // Import uuid

Vue.use(Vuex)
Vue.use(VueAxios, axios)
const base = IP_ADRESS + 'api/'

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: IP_ADRESS + 'api/'
})

export const store = new Vuex.Store({
  strict: false,
  state: {
    userIdentifier:"",
    artefacts: [],
    collections: [],
    groups: [],
    isAuthenticated: false,
    token: '',
    user: {},
    users: [],
    lang: 'ro',
    languages: {
      lang: {
        ro: {
          layout: {
            home: 'Acasa',
            explore: 'Cerceteaza',
            artefacts: 'Postari',
            collections: 'Colectii',
            groups: 'Grupuri',
            about: 'Despre noi',
            termsconditions: 'Termeni si conditii',
            language: 'Limba',
            search: 'Cauta',
            addartefact: 'Adauga Postare',
            managetags: 'Administreaza Colectii',
            managegroups: 'Administreaza Grupuri',
            tasks: 'Tasks',
            users: 'Utilizatori',
            settings: 'Setari',
            messaging: 'Mesaje',
            myaccount: 'Contul meu',
            logout: 'Delogheaza-te'
          },

          home: {
            quote: 'Mareste-ti barierele culturale',
            featuredArtefacts: 'Postari Prezentate',
            featuredArtefactParagraph: '',
            MostViewed: 'Cele mai Vizitate',
            MostFavourited: 'Favoritele Comunitatii',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filtreaza',
            artefacts: 'Postari',
            collections: 'Colectii',
            groups: 'Grupuri',
            byDate: 'Dupa data',
            startDate: 'Data inceput',
            endDate: 'Data sfarsit',
            byLocation: 'Dupa Locatie',
            insertLocation: 'Cauta locatia aici',
            sortBy: 'Sorteaza',
            mostPopular: 'Cele mai populare',
            newest: 'Cele mai noi',
            oldest: 'Cele mai vechi'
          },

          myAccount: {
            myArtefacts: 'Postarile Mele',
            favourites: 'Favoritele Mele',
            username: 'Username',
            password: 'Parola',
            repeatPassword: 'Repeta Parola',
            profileImage: 'Imagine de Profil',
            indicatesReqField: '*Indica informatiile obligatorii',
            close: 'Inchide',
            save: 'Salveaza'
          },

          tasks: {
            tasks: 'Taskuri',
            previewText: 'Selecteaza o postare pentru a vedea preview-ul...',
            newArtefacts: 'Postari Noi'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Tine-ma minte',
            forgotPassword: 'Ai uitat Parola?',
            createAccount: 'Creeaza-ti un cont',
            signInFb: 'Sign in cu Facebook',
            signInG: 'Sign in cu Google',
            signInM: 'Sign in cu Microsoft',
            termaConditionsAccept: 'Am citit si accept termenii si conditiile'
          },

          messaging: {
            tabRead: 'Citeste',
            tabWrite: 'Scrie',
            receiver: 'Mesaje primite',
            preview: 'Selectati un mesaj pentru a vedea un preview...',
            select: 'Selecteaza',
            compose: 'Compune',
            inputUser: 'Scrieti un usermane...',
            send: 'Trimite',
            selectUsers: 'Selecteaza utilizatori pentru a trimite mesaje...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Scrieti un usermane...'
          },

          collectionCard: {
            expansion: 'Artefacte in aceasta colectie'
          },

          groupCard: {
            expansion: 'Colectii in aceast grup'
          },

          artefactSingle: {
            delete: 'Esti sigur ca vrei sa stergi acest artefact?',
            btnyes: 'Da',
            btnno: 'Nu',
            addedBy: 'Adaugat de',
            browser: 'Browser-ul tau nu suporta acest format audio'
          },

          addArtefact: {
            uploadImage: 'Incarcati imagine',
            title: 'Titlul Artefactului',
            description: 'Descrierea Artefactului',
            tags: 'Numele tagurilor',
            moreInfo: 'Pentru a adauga mai multe informatii, apasa <v-icon>add_box </v-icon>, apoi apasa <v-icon>save </v-icon> pentru a salva artefactul!'
          },

          collectionSingle: {
            about: 'Despre aceasta Colectie',
            readMore: 'CITESTE MAI MULT',
            location: 'Locatiile acestei Colectii',
            artefacts: 'Ultimele Artefacte din aceasta Colectie',
            show: 'VEZI TOATE ARTEFACTELE',
            readLess: 'CITESTE MAI PUTIN',
            delete: 'Esti sigur ca vrei sa stergi aceasta colectie?'
          },

          groupSingle: {
            about: 'Despre aceast Grup',
            readMore: 'CITESTE MAI MULT',
            collections: 'Ultimele Colectii din aceast Grup',
            show: 'VEZI TOATE COLECTIILE',
            readLess: 'CITESTE MAI PUTIN',
            delete: 'Esti sigur ca vrei sa stergi aceast grup?'
          },

          contact: {
            title: 'Contacteaza-ne!',
            nume: 'Nume',
            prenume: 'Prenume',
            mail: 'E-mail',
            telefon: 'Telefon',
            mesaj: 'Mesaj'
          }

        },
        en: {

          layout: {
            home: 'Home',
            explore: 'Explore',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups of Collections',
            about: 'About Us',
            termsconditions: 'Terms and Conditions',
            language: 'Language',
            search: 'Search',
            addartefact: 'Add Artefact',
            managetags: 'Manage Collections',
            managegroups: 'Manage Groups',
            tasks: 'Tasks',
            users: 'Users',
            settings: 'Settings',
            messaging: 'Messages',
            myaccount: 'My Account',
            logout: 'Sign out'
          },

          home: {
            quote: 'explore your <b>culture</b> <br> <i>beyond limits</i>',
            featuredArtefacts: 'Featured Artefacts',
            featuredArtefactParagraph: '',
            MostViewed: 'Most Viewed Artefacts',
            MostFavourited: 'Favourites',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filter List',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups',
            byDate: 'By Date',
            startDate: 'Start Date',
            endDate: 'End Date',
            byLocation: 'By Location',
            insertLocation: 'Insert a location',
            sortBy: 'Sort by',
            mostPopular: 'Most popular',
            newest: 'Newest',
            oldest: 'Oldest'
          },

          myAccount: {
            myArtefacts: 'MY ARTEFACTS',
            favourites: 'FAVOURITES',
            username: 'Username',
            password: 'Password',
            repeatPassword: 'Repeat Password',
            profileImage: 'Profile Image',
            indicatesReqField: '*indicates required field',
            close: 'Close',
            save: 'Save'
          },

          tasks: {
            tasks: 'Tasks',
            previewText: 'Select an artefact to see a preview...',
            newArtefacts: 'New Added Artefacts'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Remember Me',
            forgotPassword: 'Forgot Password?',
            createAccount: 'Create Account',
            signInFb: 'Sign in with Facebook',
            signInG: 'Sign in with Google',
            signInM: 'Sign in with Microsoft',
            termaConditionsAccept: 'I accept the Terms and Conditions'
          },

          messaging: {
            tabRead: 'Read',
            tabWrite: 'Write',
            receiver: 'Inbox',
            preview: 'Select a message for a preview...',
            select: 'Select',
            compose: 'Compose',
            inputUser: 'Type in a username...',
            send: 'Send',
            selectUsers: 'Select users to send messages...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Type in a username...'
          },

          collectionCard: {
            expansion: 'Artefacts in this collection'
          },

          groupCard: {
            expansion: 'Groups in this collection'
          },

          artefactSingle: {
            delete: 'Are you sure you want to delete this artefact?',
            btnyes: 'Yes',
            btnno: 'No',
            addedBy: 'Added by',
            browser: 'Your browser does not support this audio format'
          },

          addArtefact: {
            uploadImage: 'Upload Image',
            title: 'Artefact Title',
            description: 'Artefact Description',
            tags: 'Tags',
            moreInfo: 'To add more info, press <v-icon>add_box </v-icon>, then press <v-icon>save </v-icon> to save the artefact!'
          },

          collectionSingle: {
            about: 'About this Collection',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            location: 'Locations of this Collection',
            artefacts: 'Latest Artefacts of this Collection',
            show: 'SEE ALL ARTEFACTS',
            delete: 'Are you sure you want to delete this collection?'
          },

          groupSingle: {
            about: 'About this Group',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            collections: 'Latest Collections of this Group',
            show: 'SEE ALL COLLECTIONS',
            delete: 'Are you sore you want to delete this group?'

          },
          contact: {
            title: 'Contact Us!',
            nume: 'Name',
            prenume: 'Surname',
            mail: 'E-mail',
            telefon: 'Phone',
            mesaj: 'Message'
          }
        },
        sr: {

          layout: {
            home: 'Home',
            explore: 'Explore',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups of Collections',
            about: 'About Us',
            termsconditions: 'Terms and Conditions',
            language: 'Language',
            search: 'Search',
            addartefact: 'Add Artefact',
            managetags: 'Manage Collections',
            managegroups: 'Manage Groups',
            tasks: 'Tasks',
            users: 'Users',
            settings: 'Settings',
            messaging: 'Messages',
            myaccount: 'My Account',
            logout: 'Sign out'
          },

          home: {
            quote: 'explore your <b>culture</b> <br> <i>beyond limits</i>',
            featuredArtefacts: 'Featured Artefacts',
            featuredArtefactParagraph: '',
            MostViewed: 'Most Viewed Artefacts',
            MostFavourited: 'Favourites',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filter List',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups',
            byDate: 'By Date',
            startDate: 'Start Date',
            endDate: 'End Date',
            byLocation: 'By Location',
            insertLocation: 'Insert a location',
            sortBy: 'Sort by',
            mostPopular: 'Most popular',
            newest: 'Newest',
            oldest: 'Oldest'
          },

          myAccount: {
            myArtefacts: 'MY ARTEFACTS',
            favourites: 'FAVOURITES',
            username: 'Username',
            password: 'Password',
            repeatPassword: 'Repeat Password',
            profileImage: 'Profile Image',
            indicatesReqField: '*indicates required field',
            close: 'Close',
            save: 'Save'
          },

          tasks: {
            tasks: 'Tasks',
            previewText: 'Select an artefact to see a preview...',
            newArtefacts: 'New Added Artefacts'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Remember Me',
            forgotPassword: 'Forgot Password?',
            createAccount: 'Create Account',
            signInFb: 'Sign in with Facebook',
            signInG: 'Sign in with Google',
            signInM: 'Sign in with Microsoft',
            termaConditionsAccept: 'I accept the Terms and Conditions'
          },

          messaging: {
            tabRead: 'Read',
            tabWrite: 'Write',
            receiver: 'Inbox',
            preview: 'Select a message for a preview...',
            select: 'Select',
            compose: 'Compose',
            inputUser: 'Type in a username...',
            send: 'Send',
            selectUsers: 'Select users to send messages...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Type in a username...'
          },

          collectionCard: {
            expansion: 'Artefacts in this collection'
          },

          groupCard: {
            expansion: 'Groups in this collection'
          },

          artefactSingle: {
            delete: 'Are you sure you want to delete this artefact?',
            btnyes: 'Yes',
            btnno: 'No',
            addedBy: 'Added by',
            browser: 'Your browser does not support this audio format'
          },

          addArtefact: {
            uploadImage: 'Upload Image',
            title: 'Artefact Title',
            description: 'Artefact Description',
            tags: 'Tags',
            moreInfo: 'To add more info, press <v-icon>add_box </v-icon>, then press <v-icon>save </v-icon> to save the artefact!'
          },

          collectionSingle: {
            about: 'About this Collection',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            location: 'Locations of this Collection',
            artefacts: 'Latest Artefacts of this Collection',
            show: 'SEE ALL ARTEFACTS',
            delete: 'Are you sure you want to delete this collection?'
          },

          groupSingle: {
            about: 'About this Group',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            collections: 'Latest Collections of this Group',
            show: 'SEE ALL COLLECTIONS',
            delete: 'Are you sore you want to delete this group?'

          },
          contact: {
            title: 'Contact Us!',
            nume: 'Name',
            prenume: 'Surname',
            mail: 'E-mail',
            telefon: 'Phone',
            mesaj: 'Message'
          }
        }
      }
    }

  },
  mutations: {
    loadLanguages: (state, {
      list
    }) => {
      state.languages = list
    },
    newUserIdentifier (state,payload){
      state.userIdentifier = payload
    },
    changeLang (state, payload) {
      state.lang = payload
    },
    createArtefact (state, payload) {
      state.artefacts.push(payload)
    },
    createCollection (state, payload) {
      state.collections.push(payload)
    },
    createGroup (state, payload) {
      state.groups.push(payload)
    },
    loadArtefacts: (state, {
      list
    }) => {
      state.artefacts = list
    },
    loadCollections: (state, {
      list
    }) => {
      state.collections = list
    },
    loadGroups: (state, {
      list
    }) => {
      state.groups = list
    },
    updateGroups (state, payload) {

    },
    updateLang (state, payload) {

    },
    deleteArtefact (state, payload) {

    },
    updateCollection (state, payload) {

    },
    updateArtefact (state, payload) {

    },
    deleteGroup (state, payload) {

    },
    deleteCollection (state, payload) {

    },
    createToken (state, payload) {
      state.token = payload
    },
    createUser (state, payload) {
      state.user = payload
      state.isAuthenticated = true
    },
    logOut (state) {
      state.user = {}
      state.isAuthenticated = false
      state.token = ''
    },
    loadUsers: (state, {
      list
    }) => {
      state.users = list
    },
    changeUserStatus: (state, payload) => {
      if (state.user._id == payload.id) {
        state.user = {}
        state.isAuthenticated = false
      }
      for (var user of state.users) {
        if (user._id == payload.id) { user.role = payload.role }
      }
    }
  },
  actions: {
    setUserIdentifier({commit}){
      const newToken= uuid.v1();
      commit("newUserIdentifier",newToken)
    },
    updateCurrentUser: function ({
      commit
    }, payload) {
      let config = {
        headers: {
          Authorization: 'Basic ' + payload.token
        }
      }
      axios.get(base + 'me')
        .then((response) => {
          commit('createUser', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateLang: function ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        axios.put(base + 'languages', payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, error => {
        reject(error)
      })

      // axios.put(base + 'languages'  , payload)
      //     .then((response) => {
      //         console.log(response)

      //     })
      //     .catch((error) => {
      //         console.log(error);

      //     });
      // store.commit('updateLanguage', payload)

      // Reach out to mongodb and store it
      // axios.post(base + 'languages', payload)
      //     .then((response) => {
      //         store.commit('updateLanguages', response.data)
      //     })
      //     .catch((error) => {
      //         console.log(error);

      //     });
    },
    createArtefact ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        axios.post(base + 'artefacts', payload)
          .then((response) => {
            commit('createArtefact', response.data)
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    recoverPass ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        axios.post(base + 'forgot', payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    recoverChangePasswordGet ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        axios.get(base + 'reset/' + payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    recoverChangePasswordPost ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        axios.post(base + 'reset/' + payload.token, payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    createToken ({
      commit
    }, payload) {
      commit('createToken', payload)
    },
    changeLang ({
      commit
    }, payload) {
      commit('changeLang', payload)
    },
    logOut ({
      commit
    }) {
      commit('logOut')
    },
    createUser ({
      commit
    }, payload) {
      commit('createUser', payload)
    },
    createCollection ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        axios.post(base + 'collections', payload)
          .then((response) => {
            resolve(response)
            commit('createCollection', response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    addToFavorites ({
      commit
    }, payload) {
      axios.post(base + 'artefacts/favorite', payload)
        .then((response) => {
          commit('addToFavorites', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    unFavorite ({
      commit
    }, payload) {
      axios.delete(base + 'artefacts/favorite', payload)
        .then((response) => {
          commit('addToFavorites', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSocialUser ({
      commit
    }, payload) {
      let config = {
        headers: {
          Authorization: 'Basic ' + payload
        }
      }

      axios.get(base + '/me', config)
        .then((response) => {
          commit('createUser', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeUserStatus ({
      commit
    }, payload) {
      let config = {
        headers: {
          Authorization: 'Basic ' + payload.token
        }
      }
      var load = payload
      return new Promise((resolve, reject) => {
        axios.post(base + 'user/changestatus/' + payload.id, payload, config)
          .then((response) => {
            if (response.success = 'success') {
              resolve(response)
              console.log(load)
              commit('changeUserStatus', {
                id: load.id,
                role: load.role
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    ChangeUserInfo ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        let config = {
          headers: {
            Authorization: 'Basic ' + payload.token
          }
        }
        axios.put(base + 'user/' + payload.user._id, payload, config)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    deleteArtefact ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.delete(base + 'artefacts/' + payload._id)
        .then((response) => {
          console.log(response)
          commit('deleteArtefact', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteGroup ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.delete(base + 'groups/' + payload._id)
        .then((response) => {
          commit('deleteGroup', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteCollection ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.delete(base + 'collections/' + payload._id)
        .then((response) => {
          commit('deleteCollection', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    deleteFile ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.post(base + 'images/delete/' + payload.imageId, {
        token: payload.token,
        userId: payload.userId
      })
    },
    createGroup ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        // Reach out to mongodb and store it
        // Reach out to mongodb and store it
        axios.post(base + 'groups', payload)
          .then((response) => {
            resolve(response)
            commit('createGroup', response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error)
      })
    },
    updateCollection ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.put(base + 'collections/' + payload._id, payload)
        .then((response) => {
          store.commit('updateCollection', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateGroup ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.put(base + 'groups/' + payload._id, payload)
        .then((response) => {
          store.commit('updateGroups', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateArtefact ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.put(base + 'artefacts/' + payload._id, payload)
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
      store.commit('updateArtefact', payload)
    },
    updateArtefactVisited ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.put(base + 'artefacts/visits/' + payload.artefact._id, {
        userId: payload.userId,
        date: payload.date
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
      store.commit('updateArtefact', payload)
    },
    updateGroupVisits ({
      commit
    }, payload) {
      // Reach out to mongodb and store it
      axios.put(base + 'groups/visits/' + payload.group._id, {
        userId: payload.userId,
        date: payload.date
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateCollectionVisits ({
      commit
    }, payload) {
      console.log(payload)
      // Reach out to mongodb and store it
      axios.put(base + 'collections/visits/' + payload.collection._id, {
        userId: payload.userId,
        date: payload.date
      })
        .then((response) => {
          
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadArtefacts: function ({
      commit
    }) {
      axios.get(base + 'artefacts').then((response) => {
        commit('loadArtefacts', {
          list: response.data
        })
      }, (err) => {
        console.log(err)
      })
    },
    loadLanguages: function ({
      commit
    }) {
      axios.get(base + 'languages').then((response) => {
        commit('loadLanguages', {
          list: response.data
        })
      }, (err) => {
        console.log(err)
      })
    },
    loadCollections: function ({
      commit
    }) {
      axios.get(base + 'collections').then((response) => {
        commit('loadCollections', {
          list: response.data
        })
      }, (err) => {
        console.log(err)
      })
    },
    loadGroups: function ({
      commit
    }) {
      axios.get(base + 'groups').then((response) => {
        commit('loadGroups', {
          list: response.data
        })
      }, (err) => {
        console.log(err)
      })
    },
    loadUsers: function ({
      commit
    }) {
      axios.get(base + 'users').then((response) => {
        commit('loadUsers', {
          list: response.data
        })
      }, (err) => {
        console.log(err)
      })
    }

  },
  getters: {
    getIdentifier (state) {
      return state.userIdentifier
    },
    loadGlobLang (state) {
      return state.languages.lang
    },
    loadLang (state) {
      return state.lang
    },
    loadUsers (state) {
      return state.users
    },
    loadSingleUser (state) {
      return (userId) => {
        return state.users.find((user) => {
          return user._id === userId
        })
      }
    },
    getUserByEmail (state) {
      return (email) => {
        return state.users.find((user) => {
          return user.email === email
        })
      }
    },
    loadArtefacts (state) {
      return state.artefacts.filter((artefact) => {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true
      }).reverse()
    },
    loadUnreviewedArtefacts (state) {
      return state.artefacts.filter((artefact) => {
        return artefact.reviewed == false && artefact.title[state.lang] != ''
      })
    },
    loadToBeDeletedArtefacts (state) {
      return state.artefacts.filter((artefact) => {
        return artefact.deleted == true && artefact.title[state.lang] != ''
      })
    },
    getFavoriteArtefacts (state) {
      return state.artefacts.filter((artefact) => {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true
      }).sort(function (a, b) {
        return b.favorite.length - a.favorite.length
      }).slice(0,16)
    },
    loadPopularArtefacts (state) {
      return state.artefacts.filter((artefact) => {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true
      }).sort(function (a, b) {
        return b.visited - a.visited
      }).slice(0,16)
    },

    loadPopularGroups (state) {
      return state.groups.sort(function (a, b) {
        return b.visited - a.visited
      }).slice(0,16)
    },
    loadPopularCollections (state) {
      return state.collections.sort(function (a, b) {
        return b.visited - a.visited
      }).slice(0,16)
    },
    loadAllCollections (state) {
      return state.collections.filter(col => col.title.en != '' || col.title.ro != '' || col.title.sr != '').reverse()
    },
    loadGroups (state) {
      return state.groups.filter(col => col.title.en != '' || col.title.ro != '' || col.title.sr != '').reverse()
    },
    loadArtefactSingle (state) {
      return (artefactId) => {
        return state.artefacts.find((artefact) => {
          return artefact._id === artefactId
        })
      }
    },
    resolveName (state) {
      return (info) => {
        return state.collections.find((artefact) => {
          return artefact.title[info.lang] == info.title
        })
      }
    },
    loadRelatedArtefacts (state) {
      return (groupTitle) => {
        return state.artefacts.filter((artefact) => {
          return (artefact.collectionId.indexOf(groupTitle) > -1 && artefact.reviewed != false && artefact.deleted == false)
        })
      }
    },
    loadRelatedCollections (state) {
      return (groupTitle) => {
        return state.collections.filter((collection) => {
          return (collection.groups.indexOf(groupTitle) > -1)
        })
      }
    },
    loadCollectionSingle (state) {
      return (collectionId) => {
        return state.collections.find((collection) => {
          return collection._id === collectionId
        })
      }
    },
    loadGroupSingle (state) {
      return (groupId) => {
        return state.groups.find((group) => {
          return group._id === groupId
        })
      }
    },
    loadFavoriteArtefacts (state) {
      return (userId) => {
        return state.artefacts.filter((artefact) => {
          return artefact.favorite.includes(userId)
        })
      }
    },
    loadAddedArtefacts (state) {
      return (userId) => {
        return state.artefacts.filter((artefact) => {
          return artefact.userId == userId
        })
      }
    },
    loadFavoriteGroups (state) {
      return (userId) => {
        return state.groups.filter((group) => {
          return group.favorite.includes(userId)
        })
      }
    },
    loadFavoriteCollections (state) {
      return (userId) => {
        return state.collections.filter((collection) => {
          return collection.favorite.includes(userId)
        })
      }
    },
    getToken (state) {
      return state.token
    },
    isAdmin (state) {
      return state.user.role === 'Admin'
    },
    isContrib (state) {
      return state.user.role === 'Contributor'
    },
    isMod (state) {
      return state.user.role === 'Moderator'
    },
    isLoggedIn (state) {
      return state.isAuthenticated
    },
    getUser (state) {
      return state.user
    }
  },
  plugins: [createPersistedState()]

})



// WEBPACK FOOTER //
// ./src/store/index.js